import { apiApplicationsBase } from "@/features/applications/api";
export const apiSocialSecurity = Object.assign({}, apiApplicationsBase("socialSecurity"));
